import React, { useState } from "react";
import { useForm } from "react-hook-form";
//import { useNavigate } from "react-router-dom";
// import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { patientDetails } from "../../redux/actions/appointmentActions";
import AppointmentStep2 from "./Step2";

function AppointmentStep1() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();

  //const navigate = useNavigate();

  const [showStepTwo, setShowStepTwo] = useState(false);

  const onSubmit = (data) => {
    setShowStepTwo((value) => !value);
    dispatch(patientDetails(data));
  };

  //console.log(uuidv4());
  //console.log(formValues);

  const patientData = useSelector((state) => state.patientDetails.step1);

  //console.log(patientData);
  if (showStepTwo !== true) {
    return (
      <div className="row justify-content-md-center">
        <div className="appointmentBackground"></div>
        <div className="col col-lg-4">
          <h3 className="mt-5 mb-3">Patient Details</h3>
          <div className="clearfix"></div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card pb-3 p-3 boxviewtransperant">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="fw-bold form-label">
                        <span className="text-danger">*</span> First Name
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="patientFirstName"
                        placeholder="Enter first name"
                        defaultValue={patientData?.patientFirstName}
                        {...register("patientFirstName", { required: true })}
                      />
                      {errors.patientFirstName && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="fw-bold form-label">
                        <span className="text-danger">*</span> Last Name
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="patientLastName"
                        placeholder="Enter last name"
                        defaultValue={patientData?.patientLastName}
                        {...register("patientLastName", { required: true })}
                      />
                      {errors.patientLastName && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="fw-bold form-label">Middle Name</label>
                      <input
                        className="form-control form-control-sm"
                        name="patientMiddleName"
                        placeholder="Enter middle name"
                        defaultValue={patientData?.patientMiddleName}
                        {...register("patientMiddleName", { required: false })}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="fw-bold form-label">
                        <span className="text-danger">*</span> Birth Date
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="patientBirthdate"
                        type="date"
                        placeholder="Select birth date"
                        defaultValue={patientData?.patientBirthdate}
                        {...register("patientBirthdate", { required: true })}
                      />
                      {errors.patientBirthdate && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label className="fw-bold form-label">Gender</label>
                      <select
                        className="form-select form-select-sm"
                        name="patientGender"
                        defaultValue={patientData?.patientGender}
                        {...register("patientGender", { required: false })}
                      >
                        <option value="">Select gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="fw-bold form-label">
                        Address Line 1
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="patientAddressLine1"
                        placeholder="Enter middle name"
                        defaultValue={patientData?.patientAddressLine1}
                        {...register("patientAddressLine1", {
                          required: false,
                        })}
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label className="fw-bold form-label">
                        Address Line 2
                      </label>
                      <input
                        className="form-control form-control-sm"
                        name="patientAddressLine2"
                        placeholder="Enter middle name"
                        defaultValue={patientData?.patientAddressLine2}
                        {...register("patientAddressLine2", {
                          required: false,
                        })}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <button
                  className="btn btn-secondary btn-block"
                  style={{ width: "100%" }}
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return <AppointmentStep2 />;
  }
}

export default AppointmentStep1;
